
export const discoverStats = {
  totalProducts: 1284,
  newThisWeek: 47,
  trendingNow: 18,
  bookmarked: 9
};

export const discoverCategories = [
  'All',
  'AI Agents',
  'LLM Tools',
  'Computer Vision',
  'NLP & Text',
  'Code Assistants',
  'Image Generation',
  'Voice & Audio',
  'Robotics',
  'Data & Analytics'
];

export const discoverProducts = [
  {
    id: 'd1',
    name: 'Devin AI',
    tagline: 'The world\'s first fully autonomous AI software engineer',
    category: 'Code Assistants',
    image: 'https://public.readdy.ai/ai/img_res/9da8a265c840a3937136e4066c72f450.jpg',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20geometric%20letter%20D%20logo%20icon%20on%20solid%20black%20background%20clean%20modern%20tech%20branding&width=80&height=80&seq=disc1logo&orientation=squarish',
    url: 'https://devin.ai',
    pricing: 'From $500/mo',
    pricingModel: 'Paid',
    rating: 4.6,
    reviews: 342,
    users: '12K+',
    launchDate: '2024-12-10',
    trending: true,
    isNew: true,
    description: 'Devin can plan, write, debug, and deploy full applications autonomously. It handles complex engineering tasks end-to-end with its own shell, code editor, and browser.',
    tags: ['Autonomous', 'Coding', 'DevOps', 'Full-Stack']
  },
  {
    id: 'd2',
    name: 'Perplexity AI',
    tagline: 'AI-powered answer engine with real-time web search',
    category: 'LLM Tools',
    image: 'https://readdy.ai/api/search-image?query=modern%20AI%20search%20engine%20answer%20interface%20with%20clean%20white%20design%20showing%20search%20results%20and%20citations%20with%20subtle%20teal%20accent%20colors%20on%20minimal%20light%20background%20professional%20product%20screenshot&width=600&height=340&seq=disc2&orientation=landscape',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20geometric%20letter%20P%20logo%20icon%20on%20solid%20dark%20teal%20background%20clean%20modern%20tech%20branding&width=80&height=80&seq=disc2logo&orientation=squarish',
    url: 'https://perplexity.ai',
    pricing: 'Free / $20/mo Pro',
    pricingModel: 'Freemium',
    rating: 4.8,
    reviews: 5621,
    users: '100M+',
    launchDate: '2024-08-15',
    trending: true,
    isNew: false,
    description: 'Perplexity combines large language models with real-time web search to deliver accurate, cited answers. Pro tier unlocks GPT-4, Claude, and unlimited file uploads.',
    tags: ['Search', 'Research', 'Citations', 'LLM']
  },
  {
    id: 'd3',
    name: 'Runway Gen-3 Alpha',
    tagline: 'Next-generation AI video creation and editing platform',
    category: 'Image Generation',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20AI%20video%20generation%20platform%20interface%20showing%20video%20timeline%20and%20AI%20generated%20scenes%20with%20dramatic%20lighting%20on%20dark%20modern%20dashboard%20background%20professional%20creative%20tool%20screenshot&width=600&height=340&seq=disc3&orientation=landscape',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20geometric%20letter%20R%20logo%20icon%20on%20solid%20dark%20background%20with%20subtle%20gradient%20clean%20modern%20creative%20branding&width=80&height=80&seq=disc3logo&orientation=squarish',
    url: 'https://runwayml.com',
    pricing: 'Free / $12/mo',
    pricingModel: 'Freemium',
    rating: 4.7,
    reviews: 2890,
    users: '30M+',
    launchDate: '2024-11-20',
    trending: true,
    isNew: false,
    description: 'Gen-3 Alpha produces photorealistic video from text and image prompts with unprecedented temporal consistency. Includes motion brush, camera controls, and style transfer.',
    tags: ['Video', 'Generative AI', 'Creative', 'Text-to-Video']
  },
  {
    id: 'd4',
    name: 'Cursor IDE',
    tagline: 'The AI-first code editor built for pair programming with AI',
    category: 'Code Assistants',
    image: 'https://readdy.ai/api/search-image?query=modern%20AI%20powered%20code%20editor%20IDE%20interface%20with%20dark%20theme%20showing%20intelligent%20code%20completion%20and%20AI%20chat%20sidebar%20on%20clean%20dark%20background%20professional%20developer%20tool%20screenshot&width=600&height=340&seq=disc4&orientation=landscape',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20geometric%20cursor%20arrow%20logo%20icon%20on%20solid%20dark%20background%20clean%20modern%20developer%20branding&width=80&height=80&seq=disc4logo&orientation=squarish',
    url: 'https://cursor.com',
    pricing: 'Free / $20/mo',
    pricingModel: 'Freemium',
    rating: 4.9,
    reviews: 8734,
    users: '2M+',
    launchDate: '2024-09-05',
    trending: true,
    isNew: false,
    description: 'Cursor is a VS Code fork with deep AI integration. Tab to autocomplete multi-line edits, chat with your codebase, and use Cmd+K to edit code with natural language.',
    tags: ['IDE', 'Coding', 'Autocomplete', 'AI Pair Programming']
  },
  {
    id: 'd5',
    name: 'ElevenLabs',
    tagline: 'Ultra-realistic AI voice synthesis and cloning platform',
    category: 'Voice & Audio',
    image: 'https://readdy.ai/api/search-image?query=sleek%20AI%20voice%20synthesis%20platform%20interface%20with%20audio%20waveform%20visualization%20and%20voice%20cloning%20controls%20on%20clean%20dark%20modern%20background%20with%20warm%20orange%20accent%20colors%20professional%20audio%20tool%20screenshot&width=600&height=340&seq=disc5&orientation=landscape',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20geometric%20sound%20wave%20logo%20icon%20on%20solid%20dark%20background%20clean%20modern%20audio%20branding&width=80&height=80&seq=disc5logo&orientation=squarish',
    url: 'https://elevenlabs.io',
    pricing: 'Free / $5/mo',
    pricingModel: 'Freemium',
    rating: 4.8,
    reviews: 4210,
    users: '10M+',
    launchDate: '2024-10-01',
    trending: false,
    isNew: false,
    description: 'ElevenLabs delivers the most natural-sounding AI voices with instant voice cloning from just 30 seconds of audio. Supports 32 languages with emotional range and fine-tuning.',
    tags: ['Voice', 'TTS', 'Cloning', 'Multilingual']
  },
  {
    id: 'd6',
    name: 'Suno AI',
    tagline: 'Create full songs with vocals and instruments from text prompts',
    category: 'Voice & Audio',
    image: 'https://readdy.ai/api/search-image?query=modern%20AI%20music%20generation%20platform%20interface%20with%20colorful%20audio%20spectrum%20visualization%20and%20song%20creation%20controls%20on%20dark%20background%20with%20vibrant%20gradient%20accents%20professional%20music%20tool%20screenshot&width=600&height=340&seq=disc6&orientation=landscape',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20geometric%20music%20note%20logo%20icon%20on%20solid%20dark%20background%20with%20warm%20gradient%20clean%20modern%20music%20branding&width=80&height=80&seq=disc6logo&orientation=squarish',
    url: 'https://suno.com',
    pricing: 'Free / $10/mo',
    pricingModel: 'Freemium',
    rating: 4.5,
    reviews: 3150,
    users: '15M+',
    launchDate: '2024-12-01',
    trending: true,
    isNew: true,
    description: 'Suno v4 generates radio-quality songs with vocals, instruments, and lyrics from a simple text description. Supports genre mixing, style transfer, and custom voice training.',
    tags: ['Music', 'Generative', 'Audio', 'Text-to-Music']
  },
  {
    id: 'd7',
    name: 'Anthropic Claude 4',
    tagline: 'Advanced reasoning AI assistant with extended thinking capabilities',
    category: 'LLM Tools',
    image: 'https://readdy.ai/api/search-image?query=clean%20minimal%20AI%20chat%20assistant%20interface%20with%20elegant%20conversation%20bubbles%20and%20thinking%20process%20visualization%20on%20soft%20warm%20beige%20background%20professional%20AI%20product%20screenshot&width=600&height=340&seq=disc7&orientation=landscape',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20geometric%20abstract%20brain%20logo%20icon%20on%20solid%20warm%20beige%20background%20clean%20modern%20AI%20branding&width=80&height=80&seq=disc7logo&orientation=squarish',
    url: 'https://anthropic.com',
    pricing: 'Free / $20/mo',
    pricingModel: 'Freemium',
    rating: 4.9,
    reviews: 12400,
    users: '50M+',
    launchDate: '2025-01-15',
    trending: true,
    isNew: true,
    description: 'Claude 4 features extended thinking for complex reasoning, 200K context window, computer use capabilities, and best-in-class safety alignment. Excels at coding, analysis, and writing.',
    tags: ['LLM', 'Reasoning', 'Safety', 'Enterprise']
  },
  {
    id: 'd8',
    name: 'Midjourney v7',
    tagline: 'State-of-the-art AI image generation with photorealistic output',
    category: 'Image Generation',
    image: 'https://readdy.ai/api/search-image?query=stunning%20AI%20image%20generation%20gallery%20interface%20showing%20photorealistic%20AI%20generated%20artwork%20in%20grid%20layout%20on%20dark%20elegant%20background%20with%20subtle%20lighting%20professional%20creative%20tool%20screenshot&width=600&height=340&seq=disc8&orientation=landscape',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20geometric%20sailboat%20logo%20icon%20on%20solid%20dark%20background%20clean%20modern%20creative%20branding&width=80&height=80&seq=disc8logo&orientation=squarish',
    url: 'https://midjourney.com',
    pricing: 'From $10/mo',
    pricingModel: 'Paid',
    rating: 4.8,
    reviews: 18900,
    users: '20M+',
    launchDate: '2025-01-08',
    trending: true,
    isNew: true,
    description: 'Midjourney v7 delivers unprecedented photorealism with native web editor, real-time generation, and advanced style controls. New features include 3D generation and video previews.',
    tags: ['Image Gen', 'Art', 'Photorealistic', 'Creative']
  },
  {
    id: 'd9',
    name: 'Replit Agent',
    tagline: 'AI agent that builds and deploys full-stack apps from a prompt',
    category: 'AI Agents',
    image: 'https://readdy.ai/api/search-image?query=modern%20AI%20coding%20agent%20interface%20with%20split%20view%20showing%20chat%20and%20live%20app%20preview%20with%20deployment%20status%20on%20clean%20dark%20background%20professional%20developer%20tool%20screenshot&width=600&height=340&seq=disc9&orientation=landscape',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20geometric%20hexagon%20logo%20icon%20on%20solid%20orange%20background%20clean%20modern%20developer%20branding&width=80&height=80&seq=disc9logo&orientation=squarish',
    url: 'https://replit.com',
    pricing: 'Free / $25/mo',
    pricingModel: 'Freemium',
    rating: 4.4,
    reviews: 2100,
    users: '35M+',
    launchDate: '2024-11-10',
    trending: false,
    isNew: false,
    description: 'Replit Agent understands your requirements, sets up the environment, installs packages, writes code, and deploys your app — all from a single natural language prompt.',
    tags: ['Agent', 'Full-Stack', 'Deployment', 'No-Code']
  },
  {
    id: 'd10',
    name: 'Groq LPU Cloud',
    tagline: 'Lightning-fast LLM inference with custom Language Processing Units',
    category: 'Data & Analytics',
    image: 'https://readdy.ai/api/search-image?query=high%20performance%20AI%20inference%20platform%20dashboard%20showing%20speed%20benchmarks%20and%20API%20metrics%20with%20sleek%20dark%20interface%20and%20electric%20green%20accent%20colors%20on%20minimal%20dark%20background%20professional%20cloud%20tool%20screenshot&width=600&height=340&seq=disc10&orientation=landscape',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20geometric%20lightning%20bolt%20logo%20icon%20on%20solid%20dark%20background%20with%20green%20accent%20clean%20modern%20tech%20branding&width=80&height=80&seq=disc10logo&orientation=squarish',
    url: 'https://groq.com',
    pricing: 'Free / Pay-as-you-go',
    pricingModel: 'Freemium',
    rating: 4.7,
    reviews: 1560,
    users: '500K+',
    launchDate: '2024-10-20',
    trending: true,
    isNew: false,
    description: 'Groq\'s custom LPU chips deliver 10x faster inference than GPU-based solutions. Run Llama, Mixtral, and Gemma models at 800+ tokens/sec with a simple API.',
    tags: ['Inference', 'API', 'Speed', 'Open Source']
  },
  {
    id: 'd11',
    name: 'NotebookLM',
    tagline: 'Google\'s AI research assistant that understands your documents',
    category: 'NLP & Text',
    image: 'https://readdy.ai/api/search-image?query=clean%20AI%20document%20research%20assistant%20interface%20with%20notebook%20layout%20showing%20highlighted%20text%20and%20AI%20generated%20summaries%20on%20soft%20white%20background%20with%20subtle%20warm%20accents%20professional%20knowledge%20tool%20screenshot&width=600&height=340&seq=disc11&orientation=landscape',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20geometric%20open%20book%20logo%20icon%20on%20solid%20warm%20background%20clean%20modern%20knowledge%20branding&width=80&height=80&seq=disc11logo&orientation=squarish',
    url: 'https://notebooklm.google.com',
    pricing: 'Free',
    pricingModel: 'Free',
    rating: 4.6,
    reviews: 6780,
    users: '8M+',
    launchDate: '2024-12-18',
    trending: false,
    isNew: true,
    description: 'Upload PDFs, docs, and websites — NotebookLM creates an AI expert grounded in your sources. Generate audio overviews, ask questions, and get cited answers instantly.',
    tags: ['Research', 'Documents', 'Google', 'Citations']
  },
  {
    id: 'd12',
    name: 'Figure 02',
    tagline: 'General-purpose humanoid robot powered by advanced AI',
    category: 'Robotics',
    image: 'https://readdy.ai/api/search-image?query=sleek%20humanoid%20robot%20in%20modern%20warehouse%20environment%20performing%20tasks%20with%20advanced%20AI%20interface%20overlay%20showing%20sensor%20data%20on%20clean%20industrial%20background%20professional%20robotics%20product%20screenshot&width=600&height=340&seq=disc12&orientation=landscape',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20geometric%20humanoid%20silhouette%20logo%20icon%20on%20solid%20dark%20background%20clean%20modern%20robotics%20branding&width=80&height=80&seq=disc12logo&orientation=squarish',
    url: 'https://figure.ai',
    pricing: 'Enterprise',
    pricingModel: 'Paid',
    rating: 4.3,
    reviews: 189,
    users: '50+',
    launchDate: '2025-01-20',
    trending: true,
    isNew: true,
    description: 'Figure 02 is a commercially deployed humanoid robot with OpenAI-powered conversational AI, dexterous manipulation, and autonomous navigation for warehouse and manufacturing tasks.',
    tags: ['Humanoid', 'Robotics', 'Manufacturing', 'Autonomous']
  }
];
